<template>
  <div class="stars">
    <div class="star"
         v-on:click="click(1)"><span :class="iconClassObject(0.5)"></span></div>
    <div class="star"
         v-on:click="click(2)"><span :class="iconClassObject(1.5)"></span></div>
    <div class="star"
         v-on:click="click(3)"><span :class="iconClassObject(2.5)"></span></div>
    <div class="star"
         v-on:click="click(4)"><span :class="iconClassObject(3.5)"></span></div>
    <div class="star"
         v-on:click="click(5)"><span :class="iconClassObject(4.5)"></span></div>
  </div>
</template>

<script>
export default {
  name: 'xm-stars',
  props: {
    amount: {
      type: Number,
      required: true
    },
    readonly: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      mutableAmount: this.amount
    };
  },
  methods: {
    click(i) {
      if (this.readonly) return false;
      this.mutableAmount = Math.max((this.mutableAmount === i ? i - 1 : i), 1);
      this.$emit('change', this.mutableAmount);
    },
    iconClassObject(amount) {
      const statusClass = this.mutableAmount > amount ? 'icon-star1' : 'icon-star2';
      return [
        'icon',
        'iconfont',
        statusClass
      ];
    }
  },
  watch: {
    amount(val) {
      this.mutableAmount = val;
    }
  }
};
</script>

<style lang="less">
@import '../core/variables.less';
.stars {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: @color-primary;

  .star+.star {
    margin-left: .2rem;
  }
  .icon {
    font-size: 1.0rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Stars.vue